import { ROLES_INSTRUCTIONS } from './constants';

export const ROUTER_PATH = 'instructions';

export const ROLES_INSTRUCTIONS_ROUTES = Object.keys(ROLES_INSTRUCTIONS).map((role) => ({
  path: `/${ROUTER_PATH}/${role}`,
  name: `/${ROUTER_PATH}-${role}`,
  component: () => import('./components/RoleInstructionsStepper.vue'),
  props: {
    title: ROLES_INSTRUCTIONS[role].title,
    steps: ROLES_INSTRUCTIONS[role].steps,
    preview: ROLES_INSTRUCTIONS[role].image,
    registerLink: ROLES_INSTRUCTIONS[role].registerLink,
  },
}));

export default [
  {
    path: `/${ROUTER_PATH}`,
    name: `${ROUTER_PATH}`,
    component: () => import('./views/instructions-list.vue'),
    meta: {
      title: 'Инструкции',
    },
  },
  ...ROLES_INSTRUCTIONS_ROUTES,
];
